export enum DataMaintenance {
  active = 'aktiv',
  planned = 'geplant',
  expired = 'abgelaufen',
  replannedByDeletion = 'neu geplant durch Löschung',
  delete = 'gelöscht',
}
